import { render, staticRenderFns } from "./IPRadioObject.vue?vue&type=template&id=c99e6110&scoped=true"
import script from "./IPRadioObject.vue?vue&type=script&lang=js"
export * from "./IPRadioObject.vue?vue&type=script&lang=js"
import style0 from "./IPRadioObject.vue?vue&type=style&index=0&id=c99e6110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99e6110",
  null
  
)

export default component.exports